import { render, staticRenderFns } from "./AssetGrid.vue?vue&type=template&id=c0473800&scoped=true"
import script from "./AssetGrid.vue?vue&type=script&lang=js"
export * from "./AssetGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0473800",
  null
  
)

export default component.exports